import PhotolabTaskBuilder from "../PhotolabTaskBuilder";
import PhotolabTaskCollageMethod from "../PhotolabTaskCollageMethod";
import PhotolabTaskImageUrl from "../PhotolabTaskImageUrl";
import {defaultHandlerCatch, defaultHandlerResolver, normalizeAgeGroup, promisifyImage} from "./helpers";
import {photolabTask} from "../api";
import {ageGroups, extraKeys} from "../etc";
import {BadResultError} from "../errors";

const tasksCache = {};

function photolabTaskHelper(creative, taskName, taskConfig, options) {
  const taskCacheKey = JSON.stringify(taskConfig);
  const _options = Object.assign({
    timeout: 1000,
    interval: 1000,
  }, options);

  if (!tasksCache[taskCacheKey]) {
    tasksCache[taskCacheKey] = photolabTask(taskConfig, {
      timeout: _options.timeout,
      interval: _options.interval,
    })
  }

  return tasksCache[taskCacheKey].then((taskResult) => {
    // const copy = JSON.parse(JSON.stringify(taskResult));
    // delete copy.embedding;
    // delete copy.keypoints;
    // creative.setTask(taskName, copy);
    return taskResult;
  }).catch((err) => {
    delete tasksCache[taskCacheKey];
    throw err;
  })
}

async function checkImageIsAdultness(processing, imageUrl) {
  const questionsResults = await photolabTask(new PhotolabTaskBuilder()
    .setLanguage(processing.language)
    .addMethod(new PhotolabTaskCollageMethod({"@configId": "looklab_nsfw_questions"}))
    .addImage(new PhotolabTaskImageUrl(imageUrl))
    .buildToJs(), {timeout: 500,interval: 500})
    .then((result) => {
      return {
        answers: {
          is_nude: result.answers[0],
          is_naked: result.answers[1],
          naked_boobs: result.answers[2],
          has_nudity: result.answers[3],
          has_porno: result.answers[4],
          is_porno: result.answers[5],
          is_pornography: result.answers[6],
          porno: result.answers[7],
          naked_woman_boobs_visible: result.answers[8],
          has_explicit_nudity: result.answers[9],
        },
        isAdult: result.answers.filter((a) => a.toLowerCase() !== "no").length > 2,
      };
    });

  return questionsResults;
}

async function promptTask(processing, creative, userFileUrl) {
  const gender = processing.getExtra(extraKeys.gender);
  const ageGroup = ageGroups.find((age) => age.id === normalizeAgeGroup(processing.getExtra(extraKeys.answers).age)).value[gender];
  const seedsList = creative.getExtra(extraKeys.seeds);

  return await photolabTaskHelper(creative, "prompt", new PhotolabTaskBuilder()
    .setLanguage(processing.language)
    .addMethod(new PhotolabTaskCollageMethod({
      "@transformationId": "npp_base",
      "@configId": creative.templateId,
      "@replacements": [
        {
          parameters: ["prompt"],
          search: "{{age_group}}",
          mode: "ig",
          replacement: ageGroup,
        },
      ],
      param_sds: seedsList.first(),
      gender,
    }))
    .addImage(new PhotolabTaskImageUrl(userFileUrl))
    .setLanguage(processing.language)
    .buildToJs());
}

async function roopTask(processing, creative, cacheData, userFileUrl, promptResultFileUrl) {
  let targetFaceIndex = 0;
  const getFacesTaskResult = await photolabTaskHelper(creative, "roop_get_faces", new PhotolabTaskBuilder()
    .setLanguage(processing.language)
    .addImage(new PhotolabTaskImageUrl(promptResultFileUrl))
    .addMethod(new PhotolabTaskCollageMethod({template_name: "nn_roop", mode: "get_faces"}))
    .buildToJs());

  if (getFacesTaskResult.humans?.length > 1) {
    targetFaceIndex = getFacesTaskResult.humans
      .reduce((v, {bbox}, index) => {
        const square = (bbox.maxPoint.x - bbox.minPoint.x) * (bbox.maxPoint.y - bbox.minPoint.y);
        if (v.square < square) {
          return {index, square};
        } else {
          return v;
        }
      }, {index: 0, square: 0})
      .index;
  }

  return await photolabTaskHelper(creative, "roop", new PhotolabTaskBuilder()
    .setLanguage(processing.language)
    .addImage(new PhotolabTaskImageUrl(userFileUrl))
    .addImage(new PhotolabTaskImageUrl(promptResultFileUrl))
    .addMethod(new PhotolabTaskCollageMethod({template_name: "nn_roop", target_face_index: targetFaceIndex}))
    .buildToJs());
}

/**
 * @param {Processing} processing
 * @param {Creative} creative
 */
export default (processing, creative) => {
  return new Promise(async (resolve, reject) => {
    const userFile = processing.files.first();

    try {
      const promptTaskResult = await promptTask(processing, creative, userFile.url);

      const check = await checkImageIsAdultness(processing, promptTaskResult.resultUrl);

      if (check.isAdult) {
        throw BadResultError.nsfw();
      }

      const roopTaskResult = await roopTask(processing, creative, {}, userFile.url, promptTaskResult.resultUrl);

      await promisifyImage(roopTaskResult.resultUrl);

      creative.setFile("raw", roopTaskResult.resultUrl);
      creative.markAsProcessed(roopTaskResult.resultUrl);

      defaultHandlerResolver(creative, resolve)();
    } catch (err) {
      defaultHandlerCatch(creative, reject)(err);
    }
  });
}
